import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSENT_KEY, grantConsent, denyConsent } from '../analytics';
import './CookieBanner.css';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    grantConsent();
    setVisible(false);
  };

  const deny = () => {
    denyConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label={t('cookies.bannerLabel')}>
      <div className="cookie-banner-inner">
        <div className="cookie-banner-text">
          <strong>{t('cookies.bannerTitle')}</strong>
          <p>
            {t('cookies.bannerText')}{' '}
            <a href="/privacy" className="cookie-banner-link">{t('cookies.privacyLink')}</a>
            {' '}{t('cookies.and')}{' '}
            <a href="/cookies" className="cookie-banner-link">{t('cookies.cookiesLink')}</a>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-deny" onClick={deny}>
            {t('cookies.deny')}
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={accept}>
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
